import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { NgModule } from '@angular/core';
import { AgmCoreModule } from '@agm/core';
import { CalendarModule } from 'angular-calendar';
import { ToastrModule, ToastrService } from "ngx-toastr";

import { AppRoutingModule } from './app-routing.module';
import { AppSettings } from './core/app.settings';

import { AppComponent } from './app.component';
import { environment } from '../environments/environment';
import { ConfirmDialogService } from './core/components/confirm-dialog/confirm-dialog.service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarConfigInterface, PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { MenuService } from './core/components/menu/menu.service';

import { MultiselectDropdownModule } from 'angular-2-dropdown-multiselect';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { FileUploadModule } from 'ng2-file-upload';
import { LoadingModule } from 'ngx-loading';
import { PipesModule } from './core/pipes/pipes.module';
import { BrowserModule } from '@angular/platform-browser';
import { SharedModule } from './shared/shared.module';
import { CoreModule } from './core/core.module';
import { MainInterceptor } from './core/interceptors/main.interceptor';
import { MsalInterceptor, MsalModule, MsalService } from '@azure/msal-angular';
import { AuthService } from "./auth/auth.service";

import { UnauthGuard } from "./auth/guards/unauth-guard.service";
import { AuthGuard } from "./auth/guards/auth-guard.service";
import { FleetManagerGuard } from './auth/guards/fleet-manager-guard.service';
import { PortalGuard } from './auth/guards/portal-guard.service';
import { AuthModule } from './auth/auth.module';
import { RolesGuard } from './auth/guards/roles-guard.service';
import { DeveloperModule } from './developer/developer.module';
import { DeveloperGuard } from './auth/guards/developer-guard.service';
import { FormGuardGuard } from './shared/guard/form-guard.guard';
import { SharedService } from './shared/shared.service.ts';
import { ConfigService } from './config.service';
import { SignalRService } from './shared/signalR/signalR.service';
import { SharedServicesModule } from './shared-services/shared-services.module';
import { UserPageTrackingService } from './shared/signalR/userPageTrackingService';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = { suppressScrollX: true };

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    BrowserAnimationsModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyDe_oVpi9eRSN99G4o6TwVjJbFBNr58NxE'
    }),
    CalendarModule.forRoot(),
    AppRoutingModule,
    HttpClientModule,
    MsalModule.forRoot(
      {
        authority: `https://login.microsoftonline.com/${environment.azureAdTenantId}`,
        clientID: environment.azureAdClientId,
        redirectUri: environment.azureAdRedirectUrl,
        navigateToLoginRequestUrl: false,
        cacheLocation: "localStorage",
        storeAuthStateInCookie: false,

        consentScopes: ["User.Read", "profile"]
      }),
    ToastrModule.forRoot(),
    PerfectScrollbarModule,
    NgbModule.forRoot(),
    MultiselectDropdownModule,
    ReactiveFormsModule,
    NgxDatatableModule,
    NgxChartsModule,
    PipesModule,
    LoadingModule,
    FileUploadModule,
    NgxDatatableModule,
    SharedModule,
    CoreModule,
    AuthModule,
    DeveloperModule,
    SharedServicesModule.forRoot()
  ],
  declarations: [
    AppComponent,
  ],
  providers: [
    AppSettings,
    AuthService,
    MenuService,
    ToastrService,
    SignalRService,
    UserPageTrackingService,
    ConfirmDialogService,
    SharedService,
    ConfigService,
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MainInterceptor,
      multi: true
    },
    MsalService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    UnauthGuard,
    AuthGuard,
    FleetManagerGuard,
    PortalGuard,
    RolesGuard,
    DeveloperGuard,
    FormGuardGuard,
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts